import { Component, OnInit, OnDestroy, Input, HostListener, ElementRef, Output, EventEmitter, Inject, PLATFORM_ID } from '@angular/core';
import { ReservationList } from '../../../_models/reservation.model';
import { CommonModule, isPlatformBrowser } from "@angular/common";
import { MenuStateService } from '../../../_services/app/menu-state.service';
import { Router } from '@angular/router';
import { AdminUserService } from '../../../_services/api/admin-user.service';
import { NotificationService } from '../../../_services/app/notification.service';
import { ReservationAdminService } from '../../../_services/api/reservation-admin.service';
import { OfferUtilsService } from '../../../_utils/offer-utils.service';

@Component({
  selector: 'app-admin-reservation-card',
  imports: [CommonModule],
  templateUrl: './admin-reservation-card.component.html',
  styleUrl: './admin-reservation-card.component.scss',
})
export class AdminReservationCardComponent implements OnInit, OnDestroy {
  @Input() reservation!: ReservationList;
  @Output() reservationUpdated = new EventEmitter<void>();
  @Output() reservationDeleted = new EventEmitter<void>();
  
  menuOpen = false;
  showDeleteModal = false;
  isUpdatingVisibility = false;

  constructor(
    private menuStateService: MenuStateService,
    private notification: NotificationService,
    private elementRef: ElementRef,
    private router: Router,
    private offerUtils: OfferUtilsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {}

  ngOnInit() {
    this.menuStateService.activeMenu$.subscribe(activeId => {
      this.menuOpen = activeId === this.reservation.id;
    });
    if (isPlatformBrowser(this.platformId)) {
        document.addEventListener('click', this.closeMenu.bind(this));
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)) {
        document.removeEventListener('click', this.closeMenu.bind(this));
    }
  }

  toggleMenu(event: MouseEvent) {
    event.stopPropagation();
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    } else {
      this.menuStateService.setActiveMenu(this.reservation.id);
    }
  }

  @HostListener('document:click', ['$event'])
  closeMenu(event: Event) {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      this.menuOpen = false;
    }
    if (this.menuOpen) {
      this.menuStateService.setActiveMenu(null);
    }
  }

  formatAddress(): string {
    if (!this.reservation.address) return 'Non spécifiée';
    
    const parts: string[] = [];
    
    if (this.reservation.address.streetNumber && this.reservation.address.street) {
      parts.push(`${this.reservation.address.street} ${this.reservation.address.streetNumber}`);
    } else if (this.reservation.address.street) {
      parts.push(this.reservation.address.street);
    }
    
    if (this.reservation.address.postalCode && this.reservation.address.city) {
      parts.push(`${this.reservation.address.postalCode} ${this.reservation.address.city}`);
    } else if (this.reservation.address.postalCode) {
      parts.push(this.reservation.address.postalCode);
    } else if (this.reservation.address.city) {
      parts.push(this.reservation.address.city);
    }
    
    if (parts.length === 0) {
      return 'Non spécifiée';
    }
    
    return parts.join(', ') + ".";
  }

  details(){
    this.router.navigate(['/admin/reservations/details', this.reservation.id]);
  }

  confirmDelete(): void {
    this.menuOpen = false;
    this.showDeleteModal = true;
  }

  closeDeleteModal(): void {
    this.showDeleteModal = false;
  }

  getReservationAdminStatusClass(): string {
    return this.offerUtils.getReservationOverallStatusClass(this.reservation.reservationClientStatus, this.reservation.reservationAdminStatus);
  }

  getReservationAdminStatusText(): string {
    return this.offerUtils.getReservationOverallStatusText(this.reservation.reservationClientStatus, this.reservation.reservationAdminStatus);
  }

  canCreateNewOffer(): boolean {
    if (!this.reservation) return false;
    return this.offerUtils.canCreateOfferForReservation(this.reservation.reservationAdminStatus);
  }

  canShowCreateOfferButton(){
    return this.offerUtils.canShowCreateOfferButton(this.reservation.reservationAdminStatus);
  }
}
